import './index.less'
import { Divider, Form, Button, Input, Select } from 'ant-design-vue'
export default {
  name: 'FormCopyRole',
  props: Object.assign({
    formData: {}
  }),
  created() {
    // 实例创建完成后被立即调用
    this.$loadStoreToData(this, 'RoleModule')
  },
  mounted() {
    // 实例被挂载后调用
    this.$nextTick(() => {
      // 整个视图都渲染完毕后执行
      console.info('form mounted')
    })
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'FormCopyRole' })
    }
  },
  methods: {
    handleCancel() {
      // 取消提交事件发出
      this.$emit('cancel')
      // 重置form内容
      this.form.resetFields()
    },
    handleSubmit(e) {
      // 表单提交事件发出
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          values.code = values.name
          this.$emit('submit', values, this.form)
          // 重置form内容
          // this.form.resetFields()
        }
      })
    }
  },

  render() {
    const { getFieldDecorator } = this.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 18,
          offset: 6
        }
      }
    }
    return (
      <div class='FormCopyRole'>
        <h3>
          复制角色</h3>
        <Divider style={{ margin: '20px 0 20px' }} />
        <Form form={this.form}
          labelCol={formItemLayout.labelCol}
          wrapperCol={formItemLayout.wrapperCol}
          onSubmit={this.handleSubmit} layout='horizontal'>
          <Form.Item label="复制角色 " >
            {getFieldDecorator('copiedId', {
              rules: [
                {
                  required: true,
                  message: '请选择要复制的角色'
                }
              ]
            })(<Select placeholder='请选择要复制的角色'>
              {this.rolesPage && this.rolesPage.data && this.rolesPage.data.length > 0 ? this.rolesPage.data.map(
                (item) => {
                  return <Select.Option key={item.id}>
                    {item.name}
                  </Select.Option>
                }
              ) : ''}
            </Select>)}
          </Form.Item>
          <Form.Item label="角色名称" >
            {getFieldDecorator('roleName', {
              rules: [
                {
                  required: true,
                  message: '角色名称不可为空'
                }
              ]
            })(<Input placeholder='请输入角色名' maxLength={10} />)}
          </Form.Item>
          {/* <Form.Item label="角色编码" >
            {getFieldDecorator('code', {
              initialValue: formData.code || '',
              rules: [
                {
                  required: true,
                  message: '角色编码不可为空'
                }
              ]
            })(<Input placeholder='请输入角色密码' />)}
          </Form.Item> */}
          <Form.Item
            labelCol={tailFormItemLayout.labelCol}
            wrapperCol={tailFormItemLayout.wrapperCol} >
            <div class='btnBroup'>
              <Button type="default" onClick={this.handleCancel}>
                取消
               </Button>
              <Button type="primary" htmlType="submit" class='btnItem'>
                确定
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    )
  }
}
